"use client";
import { Tooltip as e } from "../tooltip/Tooltip.js";
import { AlertCircleIcon as t } from "../icons/AlertCircleIcon.js";
import { HelpCircleIcon as n } from "../icons/HelpCircleIcon.js";
import { FieldSource as r } from "./FieldSource.js";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import o from "clsx";
//#region src/components/fields/FieldFrame.tsx
function s({ field: s, id: c, supportId: l, error: u, children: d, counter: f, className: p }) {
	let m = s.disableConfig?.isDisabled ? s.disableConfig.reason : void 0, h = u || m || s.description;
	return /* @__PURE__ */ a("div", {
		className: o("pf:font-body pf:flex pf:min-w-0 pf:flex-col pf:gap-sm", p),
		children: [
			s.label !== void 0 && /* @__PURE__ */ a("div", {
				className: o("pf:flex pf:items-center pf:gap-xxs pf:min-w-0", s.hideLabel && "pf:sr-only"),
				children: [
					/* @__PURE__ */ a("label", {
						htmlFor: c,
						className: o("pf:text-label-13 pf:font-medium pf:wrap-anywhere", s.disableConfig?.isDisabled ? "pf:text-soft-pearl-800" : "pf:text-soft-pearl-900"),
						children: [s.label, s.required && /* @__PURE__ */ a("span", {
							"aria-hidden": "true",
							className: "pf:text-red-700",
							children: [" ", "*"]
						})]
					}),
					s.labelConfig?.optionalLabel && /* @__PURE__ */ i("span", {
						className: "pf:text-label-13 pf:text-soft-pearl-800",
						children: s.labelConfig.optionalLabel
					}),
					s.labelConfig?.help && /* @__PURE__ */ i(e, {
						content: s.labelConfig.help,
						trigger: /* @__PURE__ */ i("button", {
							type: "button",
							"aria-label": `Help for ${s.label}`,
							className: "pf:flex pf:items-center pf:justify-center pf:size-[12px] pf:border-0 pf:bg-transparent pf:p-0 pf:shrink-0 pf:text-soft-pearl-700 pf:focus-visible:outline-2 pf:focus-visible:outline-blue-700",
							children: /* @__PURE__ */ i(n, { size: 12 })
						})
					}),
					!s.hideLabel && s.sourceConfig && /* @__PURE__ */ i("span", {
						className: "pf:ms-auto",
						children: /* @__PURE__ */ i(r, { config: s.sourceConfig })
					})
				]
			}),
			(s.hideLabel || !s.label) && s.sourceConfig && /* @__PURE__ */ i("div", {
				className: "pf:flex pf:justify-end",
				children: /* @__PURE__ */ i(r, { config: s.sourceConfig })
			}),
			d,
			(h || f) && /* @__PURE__ */ a("div", {
				className: "pf:flex pf:items-start pf:gap-xs pf:text-copy-12 pf:text-soft-pearl-800",
				children: [
					u && /* @__PURE__ */ i("span", {
						"aria-hidden": "true",
						className: "pf:flex pf:h-[18px] pf:w-[12px] pf:shrink-0 pf:items-center pf:justify-center pf:text-red-900",
						children: /* @__PURE__ */ i(t, {
							size: 12,
							tone: "inherit"
						})
					}),
					/* @__PURE__ */ i("span", {
						id: l,
						"aria-live": "polite",
						className: o("pf:min-w-0 pf:flex-1 pf:wrap-anywhere", u && "pf:text-red-900"),
						children: h
					}),
					f && /* @__PURE__ */ i("span", {
						className: o("pf:shrink-0 pf:tabular-nums", u && "pf:text-red-900"),
						children: f
					})
				]
			})
		]
	});
}
var c = "pf:box-border pf:flex pf:min-w-0 pf:items-center pf:rounded-sm pf:border pf:border-solid pf:border-soft-pearl-400 pf:bg-background pf:text-soft-pearl-1000 pf:not-focus-within:not-data-invalid:not-data-disabled:hover:border-soft-pearl-500 pf:focus-within:border-blue-700 pf:focus-within:shadow-[0_0_0_2px_var(--pf-color-blue-200)] pf:data-invalid:border-red-700 pf:data-invalid:focus-within:shadow-[0_0_0_2px_var(--pf-color-red-200)] pf:data-disabled:bg-soft-pearl-100 pf:data-disabled:text-soft-pearl-700 pf:data-disabled:border-soft-pearl-300", l = "pf:box-border pf:min-w-0 pf:w-full pf:bg-transparent pf:font-body pf:font-normal pf:text-inherit pf:outline-none pf:placeholder:text-soft-pearl-700 pf:disabled:cursor-not-allowed pf:read-only:cursor-default";
//#endregion
export { s as FieldFrame, l as fieldInputClass, c as fieldShellClass };
